import { atomWithReset } from 'jotai/utils';

export const OnlineTicketSearchState = atomWithReset('');
export const VaunceAppV2TicketsSearchState = atomWithReset('');
